import { goalUuid } from "@/lib/goalExecutor";
export interface AttachedGoalContext { goal_id: string; user_id: string; title: string }
export function ownedGoalContext(value: unknown, ownerId: string | null): AttachedGoalContext | null {
  if (!value || typeof value !== "object") return null;
  const goal = value as Record<string, unknown>;
  if (!ownerId || goal.user_id !== ownerId || !goalUuid(goal.goal_id) || typeof goal.title !== "string" || !goal.title.trim() || goal.title.length > 240) return null;
  return { goal_id: goal.goal_id, user_id: ownerId, title: goal.title };
}
export function goalContextBody(value: AttachedGoalContext | null, ownerId: string) {
  const goal = ownedGoalContext(value, ownerId);
  return goal ? { goal_context: { goal_id: goal.goal_id } } : {};
}
